import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import type {UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {CommentKpiValue, CommentsQueryKey, ExpertSystemEquipmentType, YearMonth} from '../types'

type EditCommentInput = {id: string; value: string}

export const useCommentKpiEdit = (
  kpiTargetEquipmentType: ExpertSystemEquipmentType,
  hierarchyId: string,
  yearMonth: YearMonth,
  options?: UseMutationOptions<CommentKpiValue[], AxiosError<{message?: string}>, EditCommentInput>
) => {
  const queryClient = useQueryClient()

  return useMutation<CommentKpiValue[], AxiosError<{message?: string}>, EditCommentInput>({
    mutationKey: ['comment-kpi-edit-mtm-value', kpiTargetEquipmentType, hierarchyId, yearMonth],
    mutationFn: async ({id, value}) => {
      const response = await ApiClient.axiosInstance.put<CommentKpiValue[]>(
        `/expert-system/kpis/${kpiTargetEquipmentType}/mtm/${yearMonth}/${hierarchyId}/comments/${id}`,
        {content: value}
      )
      return response.data
    },
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({queryKey: [CommentsQueryKey]})
      options?.onSuccess?.(...args)
    }
  })
}
